import React from 'react';

export default function MapaEstrategicoPage() {
  return (
    <div>
      Qualidade - Mapa Estratégico (placeholder).
    </div>
  );
}

